import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IsSignupApp } from '@app/core/utilities/app.utilities';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorTransformInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // retryWhen(errors =>
      //   errors.pipe(
      //     delay(500),
      //     concatMap((error, count) => {
      //       if (count < 1 && error.status === 5xx) {
      // // retry once and if failed else throw error
      // // will be implemented in future only if it is necessary
      //         return of(error.status);
      //       }
      //       return throwError(error);
      //     }),
      //   ),
      // ),
      catchError((error: HttpErrorResponse) => {
        const code = error.status ?? error.error?.status;
        if (code !== 401 || IsSignupApp()) {
          return throwError({
            message: error.message,
            resource: error.url,
            code,
            original: error,
          });
        } // if unauthorized page will be reloaded/redirected, no need to log

        return throwError(error);
      }),
    );
  }
}
